var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.componentClasses,on:{"click":function($event){return _vm.clicked()}}},[_c('div',{staticClass:"gc-side-bar__button-collapse__wrapper"},[_c('text-content',{attrs:{"weight":'medium',"lineHeight":'multi',"size":'sm2'}},[_vm._t("default")],2),_c('icon-down-arrow')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }